import React, { ReactNode } from 'react';
import {
  ButtonKeys,
  ButtonsType,
  ButtonType,
  CloseSecondaryView,
  GetModalProps,
  GetSecondaryViewProps,
  ViewExists,
} from '../BlockInteractionsTypes';
import { ConnectActionForm } from '../forms/ContentActionForm/ConnectActionForm';
import { DeleteBlockForm } from '../forms/DeleteBlockForm/DeleteBlockForm';
import { ActionViews, DISPLAY_TYPE, Views } from '../BlockInteractions.utils';
import { ErrorBoundary } from '../../../../_lib/components/ErrorBoundary/ErrorBoundary';
import ModalDialog from '../../ModalDialog/ModalDialog';
import { ModalDialogModifier } from '../../ModalDialog/ModalDialog';
import { SubmitOrCancelForm } from '../forms/SubmitOrCancelForm/SubmitOrCancelForm';
import { SecondaryView as SecondaryViewTypes } from '../BlockInteractionsTypes';

type SecondaryView = {
  secondaryViewTypes: SecondaryViewTypes | undefined;
  buttons?: ButtonsType;
  elementType: string;
  getSecondaryViewProps: GetSecondaryViewProps;
  closeSecondaryView: CloseSecondaryView;
  viewExists: ViewExists;
  getModalProps: GetModalProps;
};

/** returns the secondaryView component */
export function SecondaryView({
  secondaryViewTypes,
  buttons,
  getSecondaryViewProps,
  closeSecondaryView,
  viewExists,
  getModalProps,
}: SecondaryView) {
  const getSecondaryView = (): ReactNode => {
    if (buttons && buttons[secondaryViewTypes as keyof Record<ButtonKeys, ButtonType>]?.View) {
      return buttons[secondaryViewTypes as keyof Record<ButtonKeys, ButtonType>].View;
    }

    switch (secondaryViewTypes) {
      case 'connectBlocks':
        return <ConnectActionForm actionType={secondaryViewTypes} {...getSecondaryViewProps()} />;
      case 'deleteBlock':
        return <DeleteBlockForm cancelAction={closeSecondaryView} {...getSecondaryViewProps()} />;
      case Views.DELETE:
      case Views.JOIN:
      case Views.JOINREQUEST:
      case Views.LEAVE:
        return <SubmitOrCancelForm cancelAction={closeSecondaryView} {...getSecondaryViewProps()} />;
      default:
        return null;
    }
  };

  if (secondaryViewTypes && viewExists(secondaryViewTypes)) {
    const View = getSecondaryView();
    if (View) {
      const v = buttons && buttons[secondaryViewTypes as any];
      if (
        ActionViews.includes(secondaryViewTypes) ||
        v?.displayType === DISPLAY_TYPE.MODAL ||
        v?.displayType === DISPLAY_TYPE.MODAl_WIDE
      ) {
        return (
          <ModalDialog
            closeModal={closeSecondaryView}
            {...getModalProps()}
            modifier={v?.displayType === DISPLAY_TYPE.MODAl_WIDE ? ModalDialogModifier.WIDE : undefined}
          >
            {View}
          </ModalDialog>
        );
      }
      return <ErrorBoundary>{View}</ErrorBoundary>;
    }
  }
}
